<template>
  <div class="olderBase">
    <el-row class="olderBase-a">
      <el-col class="marginten">
        <img src="@/assets/beadhouse/juxing.png" style="vertical-align:middle" />
        <span style="vertical-align:middle;font-size:16px;margin-left:10px">居家中心基本信息详情</span>
      </el-col>
    </el-row>
    <el-form :model="addForm" label-width="140px" ref="addForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="居家中心名称：" prop="groupName">
            <el-input v-model.trim="addForm.groupName" auto-complete="off" maxlength="25" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="居家中心说明：" prop="info">
            <el-input v-model="addForm.info" auto-complete="off" maxlength="35" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址：" prop="detailAddress">
            <el-input v-model="addForm.detailAddress" auto-complete="off" maxlength="35" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人：" prop="contactPhone">
            <el-input v-model="addForm.contactPhone" auto-complete="off" maxlength="15" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话：" prop="addressPhone">
            <el-input v-model="addForm.addressPhone" auto-complete="off" maxlength="11" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="站点类型：" prop="type">
            <el-select v-model="addForm.type" placeholder="请选择" class="width80">
              <el-option label="自营" value="0"></el-option>
              <el-option label="加盟" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 居家中心LOGO： -->
        <el-col>
          <el-form-item label="居家中心LOGO：" prop="logo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false" :on-remove="handleRemove" :http-request="uploadSectionFile"
              :before-upload="uploadSuccess">
              <img v-if="addForm.logo" :src="addForm.logo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <!-- 营业时间： -->
        <el-col>
          <el-form-item label="营业时间：" prop="time">
            <el-time-select placeholder="起始时间" v-model="addForm.startTime" :picker-options="{
              start: '06:00',
              step: '00:15',
              end: '22:30'
            }">
            </el-time-select>
            <span> - </span>
            <el-time-select placeholder="结束时间" v-model="addForm.endTime" :picker-options="{
              start: '06:00',
              step: '00:15',
              end: '22:30',
              minTime: addForm.startTime
            }">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="footer" align="center">
      <el-button type="primary" plain @click="next" :loading="addLoading">完成</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseInfo",
  data() {
    return {
      addForm: {
        logo:null
      }, //模糊搜索
      addLoading:false,
    };
  },
  methods: {
    //活动轮播图图片上传
    uploadSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.addForm.logo = res.result; //添加图片的id
            console.log(this.addForm)
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    //活动轮播图限制
    uploadSuccess(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 4MB!");
        }
      }
      return isJPG && isLt2M;
    },

    //删除图片
    handleRemove(file, fileList) {
      this.addForm.logo = null;
    },
    getInfo(){
      //getInfo
      this.$postJson("uac/group/getInfo", {}).then(res=>{
        if(res.result!=null){
          this.addForm = res.result;
          this.addForm.type = res.result.type+"";
          let times = res.result.time.split("-")
          if(times!=null && times.length>0){
            this.addForm.startTime = times[0];
            this.addForm.endTime = times[1];
          }
        }else{
          this.addForm = {
            logo:null
          }
        }
      })
    },
    next(){
      console.log(this.addForm)
      this.addForm.time = this.addForm.startTime + "-"+ this.addForm.endTime;
      let url = "uac/group/addInfo";
      //addInfo
      if(this.addForm.groupId == null){
        url = "uac/group/addInfo";
      }else{
        url = "uac/group/updateInfo";
      }
      let params = {
        time:this.addForm.startTime + "-"+ this.addForm.endTime,
        groupName:this.addForm.groupName,
        info:this.addForm.info,
        detailAddress:this.addForm.detailAddress,
        contactPhone:this.addForm.contactPhone,
        addressPhone:this.addForm.addressPhone,
        type:this.addForm.type,
        logo:this.addForm.logo
      }
      console.log(params)
      this.loading = true;
      this.$postJson(url, params).then(res =>{
        console.log(res)
        this.$message({
              message: res.message,
              type: "success",
        });
      })
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload{
  width: 88px;
  height: 88px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border: 1px dashed #d9d9d9;
  line-height: 88px;
  text-align: center;
}
.avatar {
  width: 88px;
  height: 88px;
  display: block;
}

.olderBase {
  background: #fff;

  .olderBase-a {
    height: 60px;
    line-height: 60px;
  }

  .height40 {
    height: 40px;
    line-height: 40px;
  }

  .width80 {
    width: 300px;
  }

  .footer {
    padding: 30px 0;
    background: #fff;
  }

  .oldmanmap {
    margin: 20px 5px;
    border: 1px solid rgb(228, 222, 222);

    .map {
      width: 100%;
      height: 400px;
    }
  }

  ::v-deep .crcDisOther {
    position: relative;
  }

  ::v-deep .otherAddCheck .el-input__inner {
    position: absolute;
    left: -80px;
    top: -20px;
    width: 256px;
  }

  ::v-deep .crcDisOther .el-form-item__error {
    width: 120px !important;
    position: absolute;
    top: 45px;
    left: -80px;
  }

  //地图插件·
  ::v-deep .BMap_stdMpCtrl {
    top: 50px !important;
  }

  ::v-deep .citylist_popup_main {
    margin-left: 45px;
  }

  //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }

  ::v-deep .el-dialog__body {
    padding: 10px !important;
  }

  ::v-deep .el-dialog-map {
    width: 120%;
    margin-top: -5%;

    .el-input__inner {
      width: 50%;
    }
  }
}
</style>
